import createClient, { type Middleware } from "openapi-fetch";
import type { paths } from "./schema";

export function createAiClient(
  baseUrl: string,
  getToken?: () => string | undefined,
) {
  const client = createClient<paths>({
    baseUrl: baseUrl.replace(/\/+$/, ""),
  });

  if (getToken) {
    const authMiddleware: Middleware = {
      onRequest({ request }) {
        const token = getToken();
        if (token) {
          request.headers.set("Authorization", `Bearer ${token}`);
        }
        return request;
      },
    };
    client.use(authMiddleware);
  }

  return client;
}

export type AiClient = ReturnType<typeof createAiClient>;
